import { render, staticRenderFns } from "./TabRoutes.vue?vue&type=template&id=6831b700"
import script from "./TabRoutes.vue?vue&type=script&lang=js"
export * from "./TabRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports